import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import addLogDocument from "../addLogDocument.js";
import { getDocDataById } from "../../models/DataFunctions.js";
import { auth, dbCentral } from "../../config/FirebaseConfig.js";
import { getUserById } from "../../models/UserFunctions.js";

const getCarnetUrls = async (id, prefix) => {
  // Define the endpoint URL
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}equipments/${id}/presigned-urls`;

  const body = {};
  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const userData = await getUserById(currentUser.uid); 
    const responseText = await response.text();
    const end = new Date();
    const elapsed = end - start;
    if (userData) {
      const orgId = userData.org_id;
      // Add log document
      await addLogDocument(
        url,
        prefix,
        currentUser.uid,
        orgId,
        response.status.toString(),
        "", // Additional optional fields
        "",
        JSON.stringify(body),
        responseText,
        "POST",
        elapsed
      );
    }

    // Handle response
    if (response.ok) {
        return responseText ? JSON.parse(responseText) : [];
    } else {
      console.error(`Failed to get presigned equipment file url: ${response.status}`);
      return [];
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return [];
  }
};

export default getCarnetUrls;
